<mat-slide-toggle [checked]="checked" [disabled]="disabled" [hideIcon]="hideIcon" disableRipple="true" (change)="onToggleChange($event)">
</mat-slide-toggle>
